import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import FileUploader from "../../../TCPForms/reusableComponents/FileUploader";
import ButtonWrapper from "../../components/Button";
import { InfoBox, SummaryCard, CustomAccordionSummary } from "../../components/StyledComponent";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { Col, Row } from "react-bootstrap";

const Step2 = ({ formData, handleTabChange, tenantId }) => {
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { documents } = useSelector((state) => state.formMT);
  const userInfo = Digit.UserService.getUser();
  const { t } = useTranslation();
  const isDA = formData?.department === "DA";
  const isLowRiskCase = formData?.riskType === "LOW";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const defaultValues = {
    ...formData,
  };
  const isScheme = formData?.descriptionOfLand?.schemeType === "Scheme";
  const isSelfCert =
    formData?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
    formData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const { handleSubmit, control, setValue, trigger } = useForm({ defaultValues });

  async function fetchLTPData() {
    const createdBy = userInfo?.info?.uuid;
    try {
      const response = await Digit.OBPSService.BPAREGSearch(tenantId, {}, { createdBy: createdBy });
      const ltpData = response?.Licenses?.filter((e) => e.status === "APPROVED") || [];
      const regCert = ltpData?.[0]?.tradeLicenseDetail?.applicationDocuments?.filter((e) => e.documentType === "Registration Certificate") || [];
      initFormMTDocs([...regCert, ...documents]);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }
  const migratedData = Digit.SessionStorage.get("MIGRATED_DATA");
  const migratedPlan = migratedData?.sanctionFiles?.find((item) => item.fileType === "Plan")?.fileStoreURL;
  const migratedSanctionLetter = migratedData?.sanctionFiles?.find((item) => item.fileType === "Certificate")?.fileStoreURL;
  useEffect(() => {
    fetchLTPData();
  }, []);

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  const onSubmit = (data) => {
    data = {
      ...data,
      nocDetails: formData?.nocDetails,
    };
    handleTabChange(2, data);
  };

  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        {formData?.edcrNumber && (
          <SummaryCard className="formContainer">
            <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "100%" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", padding: "2rem" }}>
                  <Grid item xs={12} md={6}>
                    <Grid container spacing={2} style={{ padding: "1rem" }}>
                      <Grid item xs={6}>
                        <strong>{"Drawing Pdf"} </strong>:
                      </Grid>
                      <Grid item xs={6}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => window.open(formData?.updatedDxfFile, "_blank")}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </table>
              </div>
            </div>
          </SummaryCard>
        )}

        <Accordion defaultExpanded>
          <CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Mandatory Documents")}</h2>
            </div>
          </CustomAccordionSummary>
          <AccordionDetails>
            <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      label={t("Architect/Engineer Registration Certificate")}
                      control={control}
                      name="Registration Certificate"
                      validationMsg="Upload File"
                      required
                      isMandatory
                      trigger={trigger}
                    />
                  </Col>

                  {!isLowRiskCase && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Calculation sheet of Estimate with Affidavit")}
                        control={control}
                        name="calculationSheet"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {!isScheme && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Khatauni")}
                        control={control}
                        name="khatauni"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {!isSelfCert && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Owner Affidavit")}
                        control={control}
                        name="ownerAffidavit"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Drawing Pdf")}
                      control={control}
                      name="drawingPdf"
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>

                  {isScheme && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        control={control}
                        label={t("Allotment Letter/Possession Letter")}
                        name="allotmentLetterPossessionLetter"
                        validationMsg="Upload File"
                        required
                        maxFiles={4}
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  <Col md={6}>
                    <FileUploader
                      label={t("Registry Deed/up to date payment certificate from property section/Hire Purchase Tentant/Agreement")}
                      control={control}
                      name="registrySaleDeedHPTA"
                      isMandatory
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>

                  {isSelfCert && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("LTP Affidavit")}
                        control={control}
                        name="ltpAffidavit"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {!isScheme && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Developer/Consortium/Sales Agreement")}
                        control={control}
                        name="developerConsortiumSalesAgreement"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {!isDA && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Upto date payment letter")}
                        control={control}
                        name="uptodatePaymentLetter"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}
                  <Col md={12}>
                    <div className="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                  </Col>
                </Row>
              </div>

              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Site Photo")}
                      control={control}
                      name="sitePhoto"
                      validationMsg="Upload File"
                      required
                      maxFiles={4}
                      tab={2}
                      trigger={trigger}
                    />
                  </Col>

                  <Col md={6}>
                    {/* <FileUploader
                      isMandatory
                      label={t("Owner Signature")}
                      control={control}
                      name="signature"
                      validationMsg="Upload File"
                      required
                      tab={2}
                      trigger={trigger}
                    /> */}
                  </Col>

                  {/* <Col md={4}>
                    <FileUploader
                      isMandatory
                      label={t("LTP Signature")}
                      control={control}
                      name="ltpSignature"
                      validationMsg="Upload File"
                      required
                      tab={2}
                      trigger={trigger}
                    />
                  </Col> */}
                  <Col md={12}>
                    <div className="text-red important-note">Note: (jpg, jpeg, png file only and Max file Size 10 MB)*</div>
                  </Col>
                </Row>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        {/* Conditional Documents Accordion */}
        <Accordion>
          <CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Conditional Documents")}</h2>
            </div>
          </CustomAccordionSummary>
          <AccordionDetails>
            <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader label={t("Structural Audit Report")} control={control} name="structuralAuditReport" validationMsg="Upload File" />
                  </Col>

                  <Col md={6}>
                    <FileUploader label={t("Additional Document if any")} control={control} name="additionalDoc" validationMsg="Upload File" />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Drawing and Design ")}
                      control={control}
                      name="structuraldrawing"
                      validationMsg="Upload File"
                    />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Stability Certificate")}
                      control={control}
                      name="structuralcertificate"
                      validationMsg="Upload File"
                    />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Design calculation Report")}
                      control={control}
                      name="calculationReport"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={6}>
                    <FileUploader
                      control={control}
                      label={t("Vetted Structure and drawing along with certificate")}
                      name="vettedStructure"
                      validationMsg="Upload File"
                    />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      label={t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer.")}
                      control={control}
                      name="annexture789"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={6}>
                    {isDA && (
                      <FileUploader
                        label={t("Upto date payment letter")}
                        control={control}
                        name="uptodatePaymentLetter"
                        validationMsg="Upload File"
                      />
                    )}
                  </Col>
                  <Col md={12}>
                    <div className="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                  </Col>
                </Row>
              </div>
              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      label={t("Approved Layout sanctioned Letter")}
                      control={control}
                      name="sanctionLetter"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={12}>
                    <div className="text-red important-note">Note: (jpg, jpeg, png file only and Max file Size 10 MB)*</div>
                  </Col>
                </Row>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Prev"
              sx={{ backgroundColor: "#CCC" }}
              onClick={() => handleTabChange(0)}
            />
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      </form>
    </section>
  );
};

export default Step2;
